<template>
    <ul class="contact-list">
        <li v-for="(user, userIndex) in contact" :key="user._id" class="contact-user clickable">
            <div class="contact-user" :data-test-id="`contact-user-${userIndex}`">
                <l-profile-picture
                    :user="user"
                    size="s"
                    class="contact-user-picture"
                    data-test-id="contact-user-picture"
                />
                <a
                    class="contact-user-name fake-link"
                    :href="`#/profile/${user._id}`"
                    data-test-id="contact-user-name"
                >
                    {{ user.firstname + " " + user.lastname }}
                </a>
            </div>
        </li>
    </ul>
</template>

<script>
import LProfilePicture from "@/components/LProfilePicture";

export default {
    components: {
        LProfilePicture,
    },
    props: {
        contact: {
            type: Array,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped>
.contact-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.contact-user {
    display: flex;
    align-items: center;
    padding: 5px;
}
.contact-user-name {
    margin-left: 10px;
}
</style>
